<template>
  <v-dialog v-model="internalShow" max-width="700px">
    <v-card class="help-modal">
      <v-card-title class="modal-title">
        AJUDA
        <v-btn icon class="close-button d-none d-md-flex" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="help-content mt-4">
        <div v-if="step === 1">
          <p class="section-title"><strong>Passo 1</strong></p>
          <p class="section-text">
            Seleciona a cor e pinta as datas conforme a tua disponibilidade:
          </p>
          <ul class="color-list section-text">
            <li><strong style="color:green">Verde</strong> → Disponível</li>
            <li><strong style="color:orange">Amarelo</strong> → Talvez</li>
            <li><strong style="color:red">Vermelho</strong> → Indisponível</li>
          </ul>
        </div>

        <div v-else-if="step === 2">
          <p class="section-title"><strong>Passo 2</strong></p>
          <p class="section-text">
            Depois vê as datas mais compatíveis entre os participantes na página de
            <strong>“resultados”</strong>.
          </p>
        </div>

        <div v-else>
          <p class="section-title"><strong>Passo 3</strong></p>
          <p class="section-text">
            Depois de todos votarem, seleciona a melhor data e carrega em
            <strong>“fechar data”</strong> para enviar email para todos os participantes com a data final.
          </p>
        </div>
      </v-card-text>

      <v-card-actions class="actions">
        <!-- Esquerda: Retroceder -->
        <v-btn v-if="showPrev" text class="back-btn" @click="prev" aria-label="Voltar">
          <span style="text-decoration: underline;">{{ prevText }}</span>
        </v-btn>

        <v-spacer></v-spacer>

        <!-- Direita: Seguinte / Percebi -->
        <v-btn text class="next-btn" @click="nextOrClose">
          <span style="text-decoration: underline;">{{ nextLabel }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'HelpModal',
  props: {
    show: { type: Boolean, default: false }
  },
  data() {
    return { step: 1, internalShow: this.show }
  },
  watch: {
    show(val) {
      this.internalShow = val
      if (val) this.step = 1
    },
    internalShow(val) {
      if (!val) this.$emit('close')
    }
  },
  computed: {
    nextLabel() { return this.step < 3 ? 'Seguinte' : 'Percebi' },
    nextRightIcon() { return this.step < 3 ? 'mdi-arrow-right' : 'mdi-check' },
    showPrev() { return this.step > 1 },
    prevText() { return 'Retroceder' }
  },
  methods: {
    nextOrClose() { this.step < 3 ? this.step++ : this.close() },
    prev() { if (this.step > 1) this.step-- },
    close() { this.internalShow = false }
  }
}
</script>

<style scoped>
/* Igual ao Termos e Condições */
.modal-title {
  background: linear-gradient(to right, #FAD2E1, #D8E2DC, #FAD2E1);
  color: black;
  font-size: 20px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-button { color: black; }

/* Mesma tipografia/spacing dos parágrafos do outro modal */
.help-content {
  padding: 20px;
  font-size: 16px;
  line-height: 1.5;
  min-height: 15vh !important;
}

/* Títulos dos passos com o mesmo “look” dos pontos (p + strong) */
.section-title { margin: 0 0 8px; font-size: 15px}
.section-text  { margin: 0 0 8px; font-size: 14px}

/* Botões */
.actions {
  padding: 12px 16px 20px;
  display: flex;
  align-items: center;
}
.back-btn { margin-right: 4px; }
.v-btn { text-transform: none; border-radius: 999px; }
</style>
